module.exports = __webpack_public_path__ + "static/media/9.47c08a53.jpg";